/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from 'react'
import { connect } from 'react-redux';
import debounce from "lodash.debounce";
import { Button, Card, CardBody, Col, Container, Input, Label, Row, UncontrolledTooltip, Dropdown, DropdownToggle, DropdownMenu, Spinner } from 'reactstrap'
import DataTable from 'react-data-table-component';
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import dayjs from 'dayjs';

import Breadcrumbs from '../../CommonElements/Breadcrumbs'
import FilterDrawer from '../../CommonElements/FilterDrawer';
import { assignRetailerToCompany as assignRetailerToCompanyAction, deleteRetailer as deleteRetailerAction, getAllRetailers as getAllRetailersAction, getFilters as getFiltersAction, setSelectedFilters as setSelectedFiltersAction, exportRetailers as exportRetailersAction } from '../../ReduxToolkit/Reducers/retailers';
import RetailerExpandedTableRow from '../../Components/Retailer/RetailerExpandedTableRow';
// import SkeletonLoadingRow from '../../CommonElements/SkeletonLoadingRow';
import { ChevronDown, ChevronRight, Eye, Trash, X, Edit, Globe, Calendar, Download } from 'react-feather';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getCompanies as getCompaniesAction, refetch as refetchAction } from '../../ReduxToolkit/Reducers/brands';
import { toast } from 'react-toastify';
import { FiExternalLink } from 'react-icons/fi';
import CompaniesDrawer from '../../Components/CompaniesDrawer';
import AddManuallyModal from '../../Components/AddManuallyModal';
import ConfirmationModal from '../../Components/ConfirmationModal';
import EditEntityNameModal from '../../Components/EditEntityNameModal';
import { getCamelCaseWord } from '../../static/brands_wholesalers_data';

function Retailers({ getAllRetailers, filtersData, getFilters, allRetailers, totalRetailers, selectedFilters, setSelectedFilters, assignRetailerToCompany, getCompanies, deleteRetailer, refetch, exportRetailers }) {
  const navigate = useNavigate();
  const [page, setPage] = useState(selectedFilters?.page || 1);
  const [confirmationModal, setConfirmationModal] = useState(false)
  const [signleDeleteBrand, setSignleDeleteBrand] = useState(false)
  const [deleteLoading, setDeleteLoading] = useState(false)
  const [itemsPerPage, setItemPerPage] = useState(10);
  const [searchText, setSearchText] = useState("");
  const [tableData, setTableData] = useState(allRetailers[page] || []);
  const [isLoading, setIsLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedRowsData, setSelectedRowsData] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [manuallyModal, setManuallModal] = useState(false);
  const [editNameModal, setEditNameModal] = useState(null);
  const [filterLoading, setFilterLoading] = useState(false);
  const companies = useSelector(state => state.brands?.companies)
  const [selectedFilter, setSelectedFilter] = useState(selectedFilters?.filters || {});
  const [createdDateRange, setCreatedDateRange] = useState({ startDate: null, endDate: null });
  const [updatedDateRange, setUpdatedDateRange] = useState({ startDate: null, endDate: null });
  const [createdDatePickerOpen, setCreatedDatePickerOpen] = useState(false);
  const [updatedDatePickerOpen, setUpdatedDatePickerOpen] = useState(false);

  useEffect(() => {
    getCompanies();
    _getFilters();
  }, []);

  // GET DATA ON PAGE CHANGE
  useEffect(() => {
    if (page) {
      // if (allRetailers[page]) {
      //   setTableData(allRetailers[page]);
      //   setIsLoading(false);
      // } else {
      _getTableData();
      // }
    }
  }, [page]);

  useEffect(() => {
    if (allRetailers[page]) {
      setTableData(allRetailers[page]);
    }
  }, [allRetailers]);

  // State Change
  useEffect(() => {
    _getTableData();
  }, [selectedFilter, itemsPerPage, searchText]);

  // Same arguments as _getTableData, minus pagination: the export gets every matching row.
  const [exportLoading, setExportLoading] = useState(false);
  const handleExport = async () => {
    setExportLoading(true);
    await exportRetailers(
      selectedFilter,
      searchText,
      createdDateRange?.startDate ? createdDateRange : null,
      updatedDateRange?.startDate ? updatedDateRange : null
    );
    setExportLoading(false);
  };

  const _getFilters = async () => {
    setFilterLoading(true);
    await getFilters();
    setFilterLoading(false);
  };

  const _getTableData = async (hideLoader = false, createdRange = createdDateRange, updatedRange = updatedDateRange) => {
    if (!hideLoader) setIsLoading(true);
    await getAllRetailers(
      page,
      selectedFilter,
      searchText,
      itemsPerPage,
      null,
      null,
      createdRange?.startDate ? createdRange : null,
      updatedRange?.startDate ? updatedRange : null
    );
    setIsLoading(false);
  };

  const _searchBrands = (inputValue) => {
    const query = inputValue?.trim();
    setPage(1);
    setSearchText(query);
  };

  const debounceFn = useCallback(debounce(_searchBrands, 1000), []);

  const _handleSearchTextChange = (e) => {
    setSearchTerm(e.target.value);
    debounceFn(e.target.value);
  };

  const handleCopyId = async (id, e) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(String(id));
      toast.success(`ID ${id} copied`);
    } catch {
      toast.error('Failed to copy ID');
    }
  };

  const handleCreatedDateChange = (dates) => {
    const [start, end] = dates
    const formatStartDate = (date) => {
      if (!date) return null
      // Start of day in local time → converted to UTC ISO string
      return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0).toISOString()
    }
    const formatEndDate = (date) => {
      if (!date) return null
      // End of day in local time → converted to UTC ISO string
      return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999).toISOString()
    }
    const newDateRange = {
      startDate: formatStartDate(start),
      endDate: formatEndDate(end)
    }
    setCreatedDateRange(newDateRange);
    if (end) {
      setCreatedDatePickerOpen(false);
      setPage(1);
      _getTableData(false, newDateRange, updatedDateRange);
    }
  };

  const handleUpdatedDateChange = (dates) => {
    const [start, end] = dates
    const formatStartDate = (date) => {
      if (!date) return null
      return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0).toISOString()
    }
    const formatEndDate = (date) => {
      if (!date) return null
      return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999).toISOString()
    }
    const newDateRange = {
      startDate: formatStartDate(start),
      endDate: formatEndDate(end)
    }
    setUpdatedDateRange(newDateRange);
    if (end) {
      setUpdatedDatePickerOpen(false);
      setPage(1);
      _getTableData(false, createdDateRange, newDateRange);
    }
  };

  const formatDateRange = (dateRange, label) => {
    if (!dateRange?.startDate && !dateRange?.endDate) return label;
    const start = dateRange?.startDate ? dayjs(dateRange.startDate).format("L") : '';
    const end = dateRange?.endDate ? dayjs(dateRange.endDate).format("L") : '';
    if (start && end) return `${start} - ${end}`;
    if (start) return `From ${start}`;
    return label;
  };

  const handleResetDateFilters = () => {
    setCreatedDateRange({ startDate: null, endDate: null });
    setUpdatedDateRange({ startDate: null, endDate: null });
    setPage(1);
    _getTableData(false, { startDate: null, endDate: null }, { startDate: null, endDate: null });
  };

  const _handleItemPerPageSelect = async (count) => {
    setPage(1);
    setItemPerPage(count);
  };

  const _handleFilterApply = (_filters) => {
    setPage(1);
    setSelectedFilter(_filters);
    setSelectedFilters({ page, filters: _filters });
  };

  const handleAssignBrandsToCompany = async (e) => {
    try {
      const payload = { company_id: Number(e.target.value) };

      if (selectedRowsData?.allSelected) {
        // payload.retailers = 'all'
        const isFilterApplied = Object.values(selectedFilter).flat().length;
        if (isFilterApplied) {
          payload.isFilterApplied = true
          payload.filters = selectedFilter
        }
        if (searchText) payload.query = searchText
      }
      payload.retailers = selectedRowsData?.selectedRows?.map((c) => ({ id: c?.id }));

      <Label className='mb-0'>{'Search'}:</Label>
      await assignRetailerToCompany(payload)
      _getTableData();
    } catch (e) {
      toast.error(e?.message || 'Something went wrong');
    } finally {
      setSelectedRowsData(null)
    }
  };


  const handleDelete = async () => {
    try {
      setDeleteLoading(true);
      const payload = {};

      if (selectedRowsData?.allSelected) {
        payload.retailers = 'all'
        const isFilterApplied = Object.values(selectedFilter).flat().length;
        if (isFilterApplied) {
          payload.isFilterApplied = true
          payload.filters = selectedFilter
        }
        if (searchText) payload.query = searchText
      } else {
        payload.retailers = selectedRowsData?.selectedRows?.length ? selectedRowsData?.selectedRows?.map((c) => ({ id: c?.id })) : [{ id: signleDeleteBrand }];
      }

      await deleteRetailer(payload)
      _getTableData();
    } catch (e) {
      toast.error(e?.message || 'Something went wrong');
    } finally {
      setDeleteLoading(false);
      setConfirmationModal(false)
    }
  };


  const handleFetch = () => {
    const ids = selectedRowsData?.selectedRows?.map((row) => row?.id);
    if (!ids?.length) return;

    refetch({ type: 'retailer', ids });
  };

  return (
    <div className='page-body'>
      <Breadcrumbs pageTitle='Retailers' parent='Home' title='Retailers Table' />
      <Container fluid>
        <Col sm={12}>
          <Card>
            {/* <CommonCardHeader headClass='pb-0 card-no-border' titleClass='mb-3' title={ChildRowsTitle} subTitle={childrenRowsSubTitle} /> */}
            <CardBody>
              <Row className="align-items-center justify-content-between">
                <Col xs="auto" className='d-flex flex-row gap-3 align-items-center'>
                  {selectedRowsData?.selectedCount > 0 && (
                    <>
                      <Input type="select" style={{ width: '150px' }} onChange={handleAssignBrandsToCompany}>
                        <option value={null}>Select</option>
                        {companies?.map((company) => (
                          <option key={company?.id} value={company?.id}>
                            {company?.name}
                          </option>
                        ))}
                      </Input>
                      <Button outline color='primary' onClick={() => setConfirmationModal(true)}><Trash /></Button>
                    </>
                  )}
                  <button style={{ border: 'none', outline: 'none', padding: '10px 15px', borderRadius: '7px' }} onClick={() => navigate(`/import-data/retailer`)}>
                    + Import Retailer
                  </button>
                  <button
                    style={{ border: 'none', outline: 'none', padding: '10px 15px', borderRadius: '7px', display: 'inline-flex', alignItems: 'center', gap: '6px' }}
                    onClick={handleExport}
                    disabled={exportLoading || !totalRetailers}
                    title={`Export all ${totalRetailers || 0} retailers matching the current search and filters`}
                  >
                    {exportLoading ? <Spinner size="sm" /> : <Download size={16} />}
                    {exportLoading ? 'Exporting...' : 'Export Excel'}
                  </button>

                  <button onClick={() => setManuallModal(true)} style={{ border: 'none', outline: 'none', padding: '10px 15px', borderRadius: '7px', color: 'white', backgroundColor: 'black' }}>
                    Add Retailer Manually
                  </button>
                  {selectedRowsData?.selectedCount > 0 && (
                    <button
                      onClick={handleFetch}
                      style={{ border: 'none', outline: 'none', padding: '10px 15px', borderRadius: '7px', color: 'white', backgroundColor: '#007bff' }}
                    >
                      Fetch
                    </button>
                  )}
                </Col>
                <Col xs="auto" className='d-flex flex-row gap-3 align-items-center flex-wrap'>
                  <div className='d-flex flex-row gap-3 align-items-center'>
                    <Input type="text" value={searchTerm} placeholder='Search name, domain or ID...' onChange={_handleSearchTextChange} />
                  </div>

                  <FilterDrawer data={filtersData} filters={selectedFilter} isLoading={filterLoading} onFilterApply={_handleFilterApply} />

                  <Dropdown isOpen={createdDatePickerOpen} toggle={() => setCreatedDatePickerOpen(!createdDatePickerOpen)}>
                    <DropdownToggle outline color="secondary" size="sm" style={{ borderRadius: '20px', padding: '8px 15px' }}>
                      <Calendar size={14} className="me-1" /> {formatDateRange(createdDateRange, 'Created')} <ChevronDown size={14} />
                    </DropdownToggle>
                    <DropdownMenu style={{ padding: '10px', minWidth: 'auto' }}>
                      <DatePicker
                        selected={createdDateRange?.startDate ? new Date(createdDateRange.startDate) : null}
                        onChange={handleCreatedDateChange}
                        startDate={createdDateRange?.startDate ? new Date(createdDateRange.startDate) : null}
                        endDate={createdDateRange?.endDate ? new Date(createdDateRange.endDate) : null}
                        selectsRange
                        inline
                        maxDate={new Date()}
                      />
                    </DropdownMenu>
                  </Dropdown>

                  <Dropdown isOpen={updatedDatePickerOpen} toggle={() => setUpdatedDatePickerOpen(!updatedDatePickerOpen)}>
                    <DropdownToggle outline color="secondary" size="sm" style={{ borderRadius: '20px', padding: '8px 15px' }}>
                      <Calendar size={14} className="me-1" /> {formatDateRange(updatedDateRange, 'Updated')} <ChevronDown size={14} />
                    </DropdownToggle>
                    <DropdownMenu style={{ padding: '10px', minWidth: 'auto' }}>
                      <DatePicker
                        selected={updatedDateRange?.startDate ? new Date(updatedDateRange.startDate) : null}
                        onChange={handleUpdatedDateChange}
                        startDate={updatedDateRange?.startDate ? new Date(updatedDateRange.startDate) : null}
                        endDate={updatedDateRange?.endDate ? new Date(updatedDateRange.endDate) : null}
                        selectsRange
                        inline
                        maxDate={new Date()}
                      />
                    </DropdownMenu>
                  </Dropdown>

                  {(createdDateRange?.startDate || updatedDateRange?.startDate) && (
                    <button type="button" className="btn btn-sm btn-outline-secondary" style={{ borderRadius: '20px' }} onClick={handleResetDateFilters}>
                      <X size={14} /> Reset Dates
                    </button>
                  )}
                </Col>
              </Row>
              <div className="table-responsive">
                <DataTable
                  striped
                  pagination
                  data={tableData}
                  className="display"
                  progressPending={isLoading}
                  expandableIcon={{ collapsed: <ChevronRight color='#999' />, expanded: <ChevronDown color='#999' /> }}
                  paginationServer // Enables server-side pagination
                  selectableRows={true}
                  paginationTotalRows={totalRetailers} // Total number of rows
                  paginationPerPage={itemsPerPage} // Number of rows per page
                  paginationDefaultPage={page} // Current page number
                  onSelectedRowsChange={setSelectedRowsData}
                  onChangePage={(newPage) => setPage(newPage)} // Page change handler
                  onChangeRowsPerPage={_handleItemPerPageSelect}
                  // onRowClicked={(row) => setIsDrawerOpen(row)}
                  columns={[
                    {
                      name: "Profile",
                      sortable: false,
                      cell: (row) => (
                        <div>
                          <Link target="_blank" to={`/profile/${row?.id}/retailer`}>
                            <Eye size={20} color='#999' />
                          </Link>
                          <button className='btn' onClick={() => setEditNameModal(row)}>
                            <Edit size={20} color='#999' />
                          </button>
                          <button className='btn' onClick={() => {
                            setSignleDeleteBrand(row?.id)
                            setConfirmationModal(true)
                          }}><Trash size={20} color='#999' /></button>
                        </div>
                      ),
                      center: true,
                      width: '180px',
                    },
                    {
                      name: 'Id',
                      selector: (row) => row?.id,
                      sortable: true,
                      center: false,
                      width: '120px',
                      cell: (row) => (
                        <span
                          onClick={(e) => handleCopyId(row?.id, e)}
                          style={{ cursor: 'pointer' }}
                          title="Click to copy"
                        >
                          {row?.id}
                        </span>
                      ),
                    },
                    {
                      name: "Retailers",
                      selector: (row) => {
                        const tooltipId = `retailer-tooltip-${row?.id}`;
                        return (
                          <>
                            <div id={tooltipId}>{row?.name} </div>
                            <UncontrolledTooltip placement='top' target={tooltipId}>{row?.name}</UncontrolledTooltip>
                          </>
                        )
                      },
                      sortable: true,
                      center: false,
                    },
                    {
                      name: "Source",
                      cell: (row) => {
                        return row?.source ? (
                          <div>
                            <div
                              className="py-1 px-2 text-center"
                              style={{
                                fontWeight: 700,
                                color: "#1565C0",
                                borderRadius: '20px',
                                textWrap: 'nowrap',
                                backgroundColor: "#E3F2FD",
                              }}
                            >
                              {getCamelCaseWord(row?.source)}
                            </div>
                          </div>
                        ) : null;
                      },
                    },
                    {
                      name: 'Website',
                      cell: (row) => {
                        const website = row.website;
                        return website ? (
                          <a
                            href={website.startsWith('http') ? website : `https://${website}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            title="Visit website"
                          >
                            <Globe size={20} color="#999" />
                          </a>
                        ) : (
                          <span>--</span>
                        );
                      },
                      sortable: false,
                      center: false,
                      minWidth: '200px',
                    },
                    {
                      name: "Created At",
                      selector: (row) => row?.created_at ? dayjs(row?.created_at).format("L") : "--",
                      sortable: true,
                      width: '180px',
                    },
                    {
                      name: "Updated At",
                      selector: (row) => row?.updated_at ? dayjs(row?.updated_at).format("L") : "--",
                      sortable: true,
                      width: '180px',
                    },
                    {
                      name: "Location",
                      selector: (row) => `${row.country || '--'}`,
                      sortable: false,
                      center: false,
                    },
                    // {
                    //   name: "Preferred Market",
                    //   selector: (row) => `${row.preferred_market?.length ? row.preferred_market[0] : '--'}`,
                    //   sortable: false,
                    //   center: false,
                    // },
                    {
                      name: "Target Group",
                      selector: (row) => `${row.target_group?.length ? row.target_group[0] : '--'}`,
                      sortable: false,
                      center: false,
                    },
                    {
                      name: "Product Category",
                      selector: (row) => `${row.product_category?.length ? row.product_category[0] : '--'}`,
                      sortable: false,
                      center: false,
                    },
                    {
                      name: "Product Style",
                      selector: (row) => `${row.style?.length ? row.style[0] : '--'}`,
                      sortable: false,
                      center: false,
                    },
                    {
                      name: "Age group",
                      selector: (row) => `${row.age?.length ? row.age[0] : '--'}`,
                      sortable: false,
                      center: false,
                    },
                    {
                      name: "Price Range",
                      selector: (row) => `${row.price?.length ? row.price[0] : '--'}`,
                      sortable: false,
                      center: false,
                    },

                  ]}
                  expandableRows={true}
                  expandableRowsComponent={RetailerExpandedTableRow}
                  customStyles={customStyles}
                />
              </div>
            </CardBody>
          </Card>
        </Col>
      </Container>
      <AddManuallyModal type='retailer' open={manuallyModal} onClose={() => setManuallModal(false)} onSuccess={_getTableData} />
      <CompaniesDrawer isOpen={Boolean(openDrawer)} type='retailer' onSuccess={_getTableData} entity={openDrawer} onClose={() => setOpenDrawer(false)} />
      <EditEntityNameModal
        type='retailer'
        name={editNameModal?.name}
        entityId={editNameModal?.id}
        open={Boolean(editNameModal)}
        onClose={() => setEditNameModal(null)}
        onSuccess={_getTableData}
      />
      <ConfirmationModal open={confirmationModal} onClose={() => setConfirmationModal(false)} onSubmit={handleDelete} isLoading={deleteLoading} />
    </div>
  );
};

const CompanyDropDownSelect = ({ row, onRowClicked }) => {
  return (
    <div className='d-flex align-items-center flex-wrap gap-2'>
      <h6 style={{ color: row?.company?.length ? '#1ca814' : '#e0210b' }}>{row?.company?.length ? 'Assigned' : 'Un-assigned'}</h6>
      <button onClick={onRowClicked} className='btn'>
        <FiExternalLink size={18} />
      </button>
    </div>
  );
};

const customStyles = {
  header: {
    style: {
      minWidth: 'auto'
    }
  },
  rows: {
    style: {
      cursor: 'pointer',
      transition: 'background-color 0.2s ease',
      '&:hover': {
        backgroundColor: '#f1f1f1',
      },
    },
  },
};


const mapStateToProps = (state) => ({
  allRetailers: state.retailers.allRetailers,
  filtersData: state.retailers?.filters,
  totalRetailers: state.retailers.totalRetailers,
  selectedFilters: state.retailers?.selectedFilters,
});

const mapDispatchToProps = {
  getFilters: getFiltersAction,
  getCompanies: getCompaniesAction,
  getAllRetailers: getAllRetailersAction,
  deleteRetailer: deleteRetailerAction,
  setSelectedFilters: setSelectedFiltersAction,
  assignRetailerToCompany: assignRetailerToCompanyAction,
  refetch: refetchAction,
  exportRetailers: exportRetailersAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(Retailers);
